<template>
  <div class="introductionDetail">
    <heads></heads>
    <!-- <img :src="pageArray.coverMap" class="topimg"/> -->
    <!-- <banners :pic="'projectQueryChart'"></banners> -->
    <div class="container" v-loading="loading">
      <div class="top-info">
        <!-- <img :src="pageArray.coverMap" class="act-img" /> -->
        <div class="right-info">
          <div class="info-title">{{pageArray.title}}</div>
          <div class="info-label">
            <span class="name-left">
             {{pageArray.name}}
              <!-- <i class="fa fa-mars" aria-hidden="true"></i> -->
            </span>
            <div class="name-right">
              <!-- <span>
                <i class="fa fa-eye" aria-hidden="true"></i> 2020
              </span> -->
              <!-- <span> -->
                <i class="fa fa-clock-o" aria-hidden="true"></i>    {{fomateDate(pageArray.createDate)}}
              <!-- </span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="html-content" v-html="pageArray.content">

      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate } from "@/util/util.js";

import axios from "axios";
export default {
  name: "introductionDetail",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      id:0,
      pageArray:[],

      loading: false
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
  computed: {
    // nav() {
    //   return this.$route.params.id;
    // }
  },
  methods: {
    fomateDate,
    getNav(index) {
      this.nav = index;
    },
    handleCurrentChange(val) {},
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    getArticleById() {
      axios
        .get(`mobile/cmsArticle/getArticleById.jhtml`, {
          params: {
            id: this.id
          }
        })
        .then(res => {
          if (res.data.success) {
            this.pageArray = res.data.output;
          } else {
            this.$vux.toast.text("系统繁忙，请稍后再试~", "middle");
          }
          this.loading = false;
        });
    }
  },
  mounted() {},
  created() {
    this.loading = true;
    this.id = this.$route.query.id;
    this.getArticleById();
  }
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.topimg{
  /* width: 100%; */
  height: 300px;
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 10px;
}
.top-info {
  display: flex;
  width: 100%;
  padding: 6px 80px;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px 3px #c7c6c6;
}
.html-content{
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
  min-height: 350px;
}
.act-img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}
.right-info {
  padding: 10px 20px;
}
.info-title {
  font-weight: bold;
}
.info-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 16px;
}
.name-left {
  margin-right: 100px;
}
.name-right {
  color: #999999;
}
.name-right > span:nth-child(1) {
  padding-right: 10px;
  border-right: 1px solid #999999;
}
.name-right > span:nth-child(2) {
  padding-left: 10px;
}
.fa-mars {
  color: #ff70b1;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Introductionview/introductionDetail.vue